
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 9h20M2 15h20M12 9v12m-7.778 0h15.556C21.005 21 22 19.657 22 18V6c0-1.657-.995-3-2.222-3H4.222C2.995 3 2 4.343 2 6v12c0 1.657.995 3 2.222 3z","stroke":"currentColor","stroke-width":"1.5"}})])
          )
        }
      }
    